import React, { useEffect, useState } from 'react'
import './Admin.css';
const StudentTableDisplay = ({ sasToken, tableName, storageAccount, refresh }) => {
    const [tableData, setTableData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const fetchTableData = async () => {
        setLoading(true);
        try {
            const url = `${storageAccount}${tableName}?${sasToken}`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    Accept: 'application/json;odata=nometadata',
                },
            })

            if (!response.ok) {
                const text = await response.text();
                throw new Error(`Fetch failed: ${text}`);
            }
            const data = await response.json();
            setTableData(data.value || []);
        } catch (err) {
            console.error('Error fetching table data:', err);
            setError('Failed to load table data. Check console for details.');
        } finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        if (sasToken && tableName) {
            fetchTableData();
        }
    }, [sasToken, tableName, storageAccount])
    useEffect(() => {
        fetchTableData(); // or whatever your fetch function is
    }, [refresh]);

    // const convertToTSV = (rows) => {
    //     if (!rows.length) return '';
    //     console.log(rows, "thes r rows");
    //     const headers = Object.keys(rows[0]);
    //     // const tsvRows = rows.map((row) =>(
    //     //     headers.map((header) => row[header] ?? "").join('\t');
    //     // ))
    //     const tsvRows = rows.map((row) =>
    //         headers.map((header) => row[header] ?? '').join('\t') // 🔁 FIXED: implicit return
    //     );

    //     return [headers.join('\t'), ...tsvRows].join('\n')
    // }
    const convertToTSV = (data) => {
  if (!data || data.length === 0) return "";

  // Collect all unique column names across the dataset
  const headers = Array.from(
    data.reduce((cols, row) => {
      Object.keys(row).forEach((key) => cols.add(key));
      return cols;
    }, new Set())
  );

  // Header row
  const tsvRows = [headers.join("\t")];

  // Add each row with empty strings for missing values
  data.forEach((row) => {
    const values = headers.map((header) =>
      row.hasOwnProperty(header) ? row[header] : ""
    );
    tsvRows.push(values.join("\t"));
  });

  return tsvRows.join("\n");
};

    const downloadTSV = () => {
        const tsv = convertToTSV(tableData);
        const blob = new Blob([tsv], { type: 'text/tab-separated-values' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${tableName}.tsv`;
        link.click();
        URL.revokeObjectURL(url);
    }
    if (loading) return <p>🔄 Loading table data...</p>;
    if (error) return <p style={{ color: 'red' }}>❌ {error}</p>;
    if (tableData.length === 0) return <p>📭 No data found in the table.</p>;
   const downloadFilteredTSV = () => {
  // Select only required fields: PartitionKey, EmailId, Password
  const filtered = tableData.map(({ PartitionKey, EmailId, Password }) => ({
    PartitionKey,
    EmailId,
    Password
  }));

  const tsvData = convertToTSV(filtered);
  const blob = new Blob([tsvData], { type: 'text/tab-separated-values' });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.download = 'students_login_credentials.tsv';
  link.click();

  URL.revokeObjectURL(url);
};

    return (
        <div className="data-table">
            <h3 className='table-heading'>📊 {tableName} </h3>
            <div className='tsvDiv'>
            <button onClick={downloadTSV} className='downloadTSVBtn'>
                📥 Download Score TSV
            </button>
            <button onClick={downloadFilteredTSV} className='downloadTSVBtn'>
                📤 Download Login Credentials TSV
            </button>
            </div>
            <table>
                <thead>
                    <tr>
                        {Object.keys(tableData[0]).map((key) => (
                            <th key={key}>{key}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {tableData.map((row, idx) => (
                        <tr key={idx}>
                            {Object.keys(tableData[0]).map((key) => (
                                <td key={key}>{row[key]}</td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default StudentTableDisplay